import { toastLocalizedOperationCatcher, toastSuccessMessage } from "./alerts";
import { trackEvent } from "./amplitude";

import { serverCreateImpersonationUrl } from "api/api-server-actions";
import { UserInformationType, UserType } from "components/server-types";
import { i18n, t } from "i18n/i18n";

export const PROFILE_PROPERTIES: (keyof UserType)[] = ["id", "email", "first_name", "last_name"];

export const getUserFullName = (user: UserInformationType | null): string => {
  if (!user) {
    return t("user_info.anonymous_user");
  }
  if (user.first_name || user.last_name) {
    return `${user.first_name} ${user.last_name}`.trim();
  }
  return user.email;
};

export const getUserShortName = (user: UserInformationType | null): string => {
  if (!user) {
    return t("user_info.anonymous_user");
  }
  if (user.last_name) {
    return `${user.first_name} ${user.last_name[0]}.`.trim();
  }
  return user.first_name || user.email;
};

export const getUserInitials = (user: UserInformationType | null): string => {
  if (!user) {
    return "??";
  }
  if (user.first_name && user.last_name) {
    return `${user.first_name[0]}${user.last_name[0]}`;
  }
  if (user.first_name) {
    return user.first_name.slice(0, 2);
  }
  if (user.last_name) {
    return user.last_name.slice(0, 2);
  }
  return "??";
};

export const handleInterfaceLanguageChange = (lang: string) => {
  i18n
    .changeLanguage(lang)
    .then(() => trackEvent("UI language Changed", { eventCategory: "General", newLanguage: lang }))
    .catch(toastLocalizedOperationCatcher("failed_to_change_language_option"));
  // Reload page, because we're not relying on react hooks to update the language
  window.location.reload();
};

export const pathToImpersonationUrl = (redemptionUrl: string) => {
  const serverDomain = window._env_.SERVER_URL.slice(0, -1) || window.location.origin;
  return `${serverDomain}${redemptionUrl}`;
};

export const createImpersonationUrl = async (userId: string) => {
  try {
    const url = await serverCreateImpersonationUrl(userId);
    toastSuccessMessage(t("user_options_menu.impersonate_user_success"));
    return pathToImpersonationUrl(url);
  } catch (error) {
    toastLocalizedOperationCatcher("failed_to_impersonate_user")(error);
  }
};
